import * as yup from 'yup';
export const blastingInfoSchema = yup.object().shape({
	address: yup.string().required('Address is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('ZIP code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip code.'),
	city: yup.string().required('City is required.'),
	phone: yup.string().required('Phone is required.'),
	afterHourPhone: yup.string().required('After hour phone is required.'),
	businessName: yup.string().required('Buisness name is requied.'),
	contactPerson: yup.string().required('Contact person is requied.'),
	title: yup.string().required('Title is requied.'),
	licenseNumber: yup.string().required('License number is requied.').matches(/^[0-9]+(-[0-9]+)*$/,'Invalid number format.'),
	jurisdiction: yup.string().required('Jurisdiction is requied.'),
});
